import React, { useState, useEffect, lazy } from 'react'
import { useIonViewDidEnter,IonPage, IonIcon, IonContent, IonHeader, IonToolbar, IonButton, IonTitle, IonGrid, IonRow, IonCol, IonAvatar, IonMenuButton, IonLabel, IonModal, isPlatform, IonCard, IonChip, IonCardContent, IonCardHeader, IonCardTitle, IonCardSubtitle, ItemReorderEventDetail, IonButtons, IonItem, IonList } from '@ionic/react'
import { arrowForward, chevronForward, mic, people, person, shareSocial, statsChart, time, walk } from 'ionicons/icons'
import { useSelector, useDispatch } from 'react-redux';
import Api from "../services/Api"

// import WebSocketClient from "../services/WebSocketClient"
import FirebaseProvider from '../services/FirebaseAnalytics'
import './MyPage.scss'
import { goToPage, goToPageWithState } from '../helpers/app_actions';
import { getMyWalks } from '../redux/actions/walkActions';
import { openAlert } from '../redux/actions/alertActions';
import { RootState } from '../redux/reducers';
import { SafetyPadding } from '../components/SafetyPadding';
import { WalkI } from '../interfaces/Walk';
import dayjs from 'dayjs';
import { openChat } from '../helpers/chat_actions';
import { shareWalk } from '../helpers/walk_actions';
const UploadPicture = lazy(() => import('../components/UploadPicture'))

const MyPage = (props: any) => {
  const firebaseProvider = FirebaseProvider.getInstance()
  const api = Api.getInstance()
  const dispatch = useDispatch()
  const logIn = useSelector((state: RootState) => state.logIn)
  const hasPRO = useSelector((state: RootState) => state.logIn.user.WTTeams)
  const walks = useSelector((state: RootState) => state.walks.walks)
  const [statistic, setStatistic] = useState({
    counter_enabled: false,
    counter_loaded: false
  })
  const [profileData, setProfileData] = useState({
    firstName: api.profile.firstName,
    lastName: api.profile.lastName,
    email: api.profile.email,
    picture: api.profile.picture,
    password: '',
  })
  const [picture, setPicture] = useState({
    open: false
  })
  const [isDisabled, setIsDisabled] = useState(true);
  const [nextWalk, setNextWalk] = useState<Array<WalkI>>([])
  const [walkNow, setWalkNow] = useState<Array<WalkI>>([])

  useEffect(() => {
    api.get('/person/statistic').then(res => {
      res.json().then(data => {
        if(data.status === 'ok') {
          setStatistic({
            counter_enabled: data.data.counter_enabled,
            counter_loaded: true
          })
        } else {
          setStatistic({
            ...statistic,
            counter_loaded: true
          })
        }
      })
    }).catch(e => console.log(e))
  }, [])

  useEffect(() => {
    setProfileData({
      firstName: logIn.user.person.firstName,
      lastName: logIn.user.person.lastName,
      email: logIn.user.person.email,
      password: '',
      picture: logIn.user.person.picture
    })
  }, [logIn]);

  useEffect(() => {
    if (isPlatform('capacitor')) {
      firebaseProvider.trackView('MyPage')
    }
    if(api.loggedIn) {
      // getData()
    }
  }, [api.loggedIn, firebaseProvider])

  useIonViewDidEnter(() => {
    // getData()
    dispatch(getMyWalks())
  });

  useEffect(() => {
    const today = new Date().getTime()
    const nextArr: Array<any> = []
    const currentArr: Array<any> = []

    walks.sort((a: any, b: any) => {
      return new Date(b.start).getTime() - new Date(a.start).getTime()
    }).find((walk: WalkI) => {
      if(currentWalk(new Date(walk.start).getTime(), new Date(dayjs(walk.start).add(walk.lengthMinutes, 'minutes').format('YYYY-MM-DD HH:mm')).getTime(), today)){
        currentArr.unshift(walk)
      } else if(new Date(walk.start).getTime() > today) {
        nextArr.unshift(walk)
        // date has not passed
      } else {
        // date has passed
      }
    })
    setNextWalk(nextArr)
    setWalkNow(currentArr)
  }, [walks])

  const currentWalk = (dateFrom: any, dateTo: any, dateCheck: any) => {
    let from = dateFrom;
    let to   = dateTo;
    let check = dateCheck;
    if((check <= to && check >= from)) {
      return true
    } else {
      return false
    }
  }

  const uploadPicture = (pic: string) => {
    const data = {
      picture: pic
    }

    api.post('/picture', data).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          api.profile.picture = data.picture;
          setProfileData({
            ...profileData,
            picture: data.picture
          });
          dispatch(openAlert({
            message: api.tr('change_saved'),
            header: api.tr('message')
          }))
        } else {
          dispatch(openAlert({
            message: `${api.tr('something_went_wrong')} ${data.message}`,
            header: api.tr('error_message')
          }))
        }
      })
    })
  }


  const handleReorder = (event: CustomEvent<ItemReorderEventDetail>) => {
    // The `from` and `to` properties contain the index of the item
    // when the drag started and ended, respectively
    // console.log('Dragged from index', event.detail.from, 'to', event.detail.to);

    // Finish the reorder and position the item in the DOM based on
    // where the gesture ended. This method can also be called directly
    // by the reorder group
    event.detail.complete();
  }

  const toggleReorder = () => {
    setIsDisabled((current) => !current);
  }

  return (
    <IonPage className="cheap_desktop myPage">
      <IonHeader>
        <IonToolbar>
          <IonGrid>
            <IonRow>
              <IonCol>
                <IonButtons>
                  <IonButton 
                    fill='clear'
                    style={{height: 'auto'}}
                    onClick={() => {
                      goToPage('/walk/user/profile/' + logIn.user.person.id)
                    }}>
                    <IonAvatar
                      slot="start"
                      className="button_shadow m-2">
                      <img alt="profile" src={api.profile.picture}/>
                    </IonAvatar>
                    {isPlatform('desktop') ? 
                    <IonLabel 
                      color="primary" 
                      slot="start" 
                      className="underline"
                    >{api.tr('my_profile')}</IonLabel>: null}
                  </IonButton>
                </IonButtons>
              </IonCol>
              <IonCol className='flex justify-content items-center'>
                <IonTitle>
                  <h2>
                    {api.tr('my_page')} 
                    {hasPRO ? <IonChip className="m-2 p-2" color="darkblue">Pro</IonChip> : null}
                  </h2>
                </IonTitle>
              </IonCol>
              <IonCol className='flex justify-end items-center'>
                <IonMenuButton menu="first" color="dark" ></IonMenuButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>
      </IonHeader>
      {isPlatform('desktop') ? 
      null :
      <>
      { logIn.user.WTTeams ? 
      null : 
      <IonToolbar color="darkblue" onClick={() => {
        goToPage('/walk/getteams')
      }}>
        <p className="text_center fullWidth flex justify-center items-center">
          {api.tr('upgrade_WT_PRO')} 
          <IonIcon icon={arrowForward} slot="end" size="large"/>
        </p>
      </IonToolbar> } </>
     }
      <IonContent id="main" className="cheap_desktop_content">
      <section>
        <IonGrid>
          <IonRow className="fullWidth flex flex-between ">
          { walkNow.length > 0 ? 
            <IonCard className="m-2" style={isPlatform('desktop') ? {width: 'calc(50% - 3rem)'} : {width: '100%'}}>
              <IonCardHeader color="primary" className="p-2">
                <IonCardTitle mode="md" >{api.tr('current_walk')}</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <IonRow className="mt-2">
                  <IonCol size="1">
                    <IonIcon icon={time} size="large" color="medium"/>
                  </IonCol>
                  <IonCol>
                    <h2>{walkNow[0].name}</h2>
                    <p>{walkNow[0].start} - { dayjs(walkNow[0].start).add(walkNow[0].lengthMinutes, 'minutes').format('HH:mm') }</p>
                  </IonCol>
                  <IonCol>
                    { walkNow[0].booked && walkNow[0].bookedByYou ? 
                    <IonChip>
                      <IonAvatar><img src={walkNow[0].personPicture} alt="" /></IonAvatar>
                      <IonLabel>{walkNow[0].personName}</IonLabel>
                    </IonChip>
                    : null }
                    { walkNow[0].booked && walkNow[0].bookedPerson ? 
                    <IonChip>
                      <IonAvatar><img src={walkNow[0].bookedPerson.personPicture} alt="" /></IonAvatar>
                      <IonLabel>{walkNow[0].bookedPerson.personPicture}</IonLabel>
                    </IonChip>
                    : null }

                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol>
                    <IonList>
                      <IonItem onClick={() => goToPage('/walk/walk/' + walkNow[0].id)}>
                        <IonLabel>{api.tr('go_to_walk')}</IonLabel>
                        <IonIcon icon={chevronForward} color="primary"/>
                      </IonItem>
                      <IonItem onClick={() => {
                        goToPageWithState('/walk/walk/' + walkNow[0].id, 'openNote')
                      }}>
                        <IonLabel>{api.tr('notes')}</IonLabel>
                        <IonIcon icon={chevronForward} color="primary"/> 
                      </IonItem>
                      { isPlatform('desktop') ? 
                      <IonItem onClick={() => {
                        goToPageWithState('/walk/walk/' + walkNow[0].id, 'openNote')
                      }}>
                        <IonLabel>Agenda</IonLabel>
                        <IonIcon icon={chevronForward} color="primary"/> 
                      </IonItem> : null }
                    </IonList>
                  </IonCol>
                  <IonCol>
                    <IonList>
                      { walkNow[0].booked ? 
                      <IonItem onClick={() => {
                        openChat(walkNow[0].bookedByYou ? walkNow[0].personId : walkNow[0].bookedPerson!.id)
                      }}>
                        <IonLabel>{api.tr('chat_with')} { walkNow[0].bookedByYou ? walkNow[0].personName : walkNow[0].bookedPerson?.firstName}</IonLabel>
                        <IonIcon icon={chevronForward} color="primary"/>
                      </IonItem>
                      : 
                        <IonItem onClick={() => shareWalk(walkNow[0].id)}>
                          <IonLabel>{api.tr('share_walk')}</IonLabel>
                          <IonIcon icon={shareSocial} color="primary"/>
                        </IonItem>
                      }
                      <IonItem>
                        <IonButton slot={isPlatform('desktop') ? 'start' : 'end'}
                          onClick={() => {
                            goToPageWithState('/walk/walk/' + walkNow[0].id, 'openCall')
                          }} 
                          color="darkblue">
                          <IonLabel>{api.tr('enter_room')}</IonLabel>
                          <IonIcon icon={mic} color="light"/>  
                        </IonButton>
                      </IonItem>
                    </IonList>
                  </IonCol>
                </IonRow>
              </IonCardContent>
            </IonCard>
            : null }
        { isPlatform('desktop') && nextWalk.length > 0 ? 
          <IonCard 
            className="m-2" 
            style={isPlatform('desktop') ? {width: 'calc(50% - 3rem)'} : {width: '100%'}}>
            <IonCardHeader className="p-2" color="teal">
              <IonCardTitle mode="md" >
                { nextWalk.length > 0 ? 'Next walk:' : 'No upcoming walks' }
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <IonRow className="mt-2">
                <IonCol size="1">
                  <IonIcon icon={time} size="large" color="medium"/>
                </IonCol>
                <IonCol>
                  <IonCardTitle>{nextWalk[0].name}</IonCardTitle>
                  <IonCardSubtitle>{nextWalk[0].start} - { dayjs(nextWalk[0].start).add(nextWalk[0].lengthMinutes, 'minutes').format('HH:mm') }</IonCardSubtitle>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol>
                  <IonList>
                    <IonItem onClick={() => goToPage('/walk/walk/' + nextWalk[0].id)}>
                      <IonLabel>{api.tr('go_to_walk')}</IonLabel>
                      <IonIcon icon={chevronForward} color="primary"/>
                    </IonItem>
                    <IonItem onClick={() => {
                      goToPageWithState('/walk/walk/' + nextWalk[0].id, 'openNote')
                    }}>
                      <IonLabel>{api.tr('notes')}</IonLabel>
                      <IonIcon icon={chevronForward} color="primary"/> 
                    </IonItem>
                    <IonItem onClick={() => {
                      goToPageWithState('/walk/walk/' + nextWalk[0].id, 'openNote')
                    }}>
                      <IonLabel>Agenda</IonLabel>
                      <IonIcon icon={chevronForward} color="primary"/> 
                    </IonItem>
                  </IonList>
                </IonCol>
                <IonCol>
                  <IonList>
                    { nextWalk[0].booked ? 
                    <IonItem  onClick={() => openChat(nextWalk[0].bookedByYou ? nextWalk[0].personId : nextWalk[0].bookedPerson!.id)}>
                        <IonLabel>Chatta med { nextWalk[0].bookedByYou ? nextWalk[0].personName : nextWalk[0].bookedPerson?.firstName}</IonLabel>
                      <IonIcon icon={chevronForward} color="primary"/>
                    </IonItem>
                    : 
                      <IonItem onClick={() => shareWalk(nextWalk[0].id)}>
                        <IonLabel>{api.tr('share_walk')}</IonLabel>
                        <IonIcon icon={shareSocial} color="primary"/>
                      </IonItem>
                    }
                    <IonItem>
                      <IonButton 
                        onClick={() => {
                          goToPageWithState('/walk/walk/' + nextWalk[0].id, 'openCall')
                        }}
                        color="darkblue">
                        <IonLabel>{api.tr('enter_room')}</IonLabel>
                        <IonIcon icon={mic} color="light"/>  
                      </IonButton> 
                    </IonItem>
                  </IonList>
                </IonCol>
              </IonRow>
            </IonCardContent>
          </IonCard> 
          : 
          <>
          { nextWalk.length > 0 ? 
            <IonCard 
              className="fullWidth m-2"
              onClick={() => goToPage('/walk/walk/' + nextWalk[0].id)}>
              <IonCardHeader className="p-2" color="teal">
                <IonToolbar color="teal">
                  <IonCardTitle mode="md" >
                    { nextWalk.length > 0 ? 'Next walk:' : 'No upcoming walks' }
                  </IonCardTitle>
                  <IonCardSubtitle mode="md" >
                  {nextWalk[0].name} - {nextWalk[0].start} - { dayjs(nextWalk[0].start).add(nextWalk[0].lengthMinutes, 'minutes').format('HH:mm') }
                  </IonCardSubtitle>
                  <IonButton slot="end" fill="clear">
                    <IonIcon icon={arrowForward} color="light" size="large"/>
                  </IonButton>
                </IonToolbar>
              </IonCardHeader>
            </IonCard>
            : 
            null }
          </>
          }
        </IonRow>

          {/* <IonRow className="flex justify-end p-2">
            <IonButton onClick={() => toggleReorder()}>
              { !isDisabled ? 'Done' : 'Reorder list' }
              { !isDisabled ? null : <IonIcon icon={reorderTwo}/> }
            </IonButton>
          </IonRow> */}
          {/* <IonReorderGroup disabled={isDisabled} onIonItemReorder={handleReorder}> */}
            <IonCard className="m-2">
              <IonCardHeader color="light" className="p-2">
                <IonRow>
                  <IonCol size="1">
                    <IonIcon icon={walk} size="large" color="teal"/>
                  </IonCol>
                  <IonCol>
                    <IonCardTitle mode="md" className="ml-2">{api.tr('my_walks')}</IonCardTitle>
                    <IonCardSubtitle mode="md" className="ml-2">{api.tr('track_walks')}</IonCardSubtitle>
                  </IonCol>
                  {/* {!isDisabled ? <IonReorder/> : null} */}
                </IonRow>
              </IonCardHeader>
              <IonCardContent> 
                <IonList onClick={() => goToPage('/walk/profile/walks')}>
                  <IonItem>
                    <IonLabel>{api.tr('view_walks')}</IonLabel>
                    <IonIcon icon={arrowForward}/>
                  </IonItem>
                </IonList>
                <IonRow className="flex justify-end items-center mt-2">
                  <IonButton onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if(nextWalk.length > 0) {
                      goToPage('/walk/profile/walks')
                    } else {
                      goToPage('/walk/create')
                    }
                  }}>
                    { nextWalk.length > 0 ? 
                      'Se promenader'
                    : 
                      api.tr('create_a_walk')
                     }
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonRow>
              </IonCardContent>
            </IonCard>
            <IonCard className="m-2" onClick={() => goToPage('/walk/statistic')}>
              <IonCardHeader color="light" className="p-2">
                <IonRow>
                  <IonCol size="1">
                    <IonIcon icon={statsChart} size="large" color="teal"/>
                  </IonCol>
                  <IonCol>
                    <IonCardTitle mode="md" className="ml-2">{api.tr('statistic')}</IonCardTitle>
                    <IonCardSubtitle mode="md" className="ml-2">{api.tr('statistic_info')}</IonCardSubtitle>
                  </IonCol>
                  {/* {!isDisabled ? <IonReorder/> : null} */}
                </IonRow>
              </IonCardHeader>
              <IonCardContent>
                {/* {statistic.counter_loaded ? 
                <IonRow className="flex justify-between items-center mt-2">
                  { statistic.counter_enabled ? 
                    <IonChip className="p-2" color="primary">
                      <IonIcon icon={checkmark}/>
                      <b>Step-counter enabled</b>
                    </IonChip> 
                    : 
                    <IonChip className="p-2" color="medium">
                      <IonIcon icon={alertCircle}/>
                      <b>Step-counter disabled</b>
                    </IonChip>
                  } 
                </IonRow> : 
                <IonRow className="flex justify-between items-center mt-2">
                  <IonChip className="p-2" color="medium"><b>Step counter loading...</b></IonChip>
                </IonRow> } */}
                <IonItem onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    goToPage('/walk/statistic')}}>
                  <IonLabel>{api.tr('view_statistic')}</IonLabel>
                  <IonButton slot="end" fill="clear">
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonItem>
                <IonItem onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  goToPage('/walk/challenges')}}>
                  <IonLabel>{api.tr('stepchallenges')}</IonLabel>
                  <IonButton slot="end" fill="clear">
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonItem>
                <IonItem onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  goToPage('/walk/stepcounter')}}>
                  <IonLabel>{api.tr('stepcounter')}</IonLabel>
                  <IonButton slot="end" fill="clear">
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonItem>
              </IonCardContent>
            </IonCard>                        
            <IonCard className="m-2" 
              routerLink='/walk/friends'>
                <IonCardHeader color="light" className="p-2">
                <IonRow>
                  <IonCol size="1">
                    <IonIcon icon={person} size="large" color="teal"/>
                  </IonCol>
                  <IonCol>
                    <IonCardTitle mode="md" className="ml-2">{api.tr('friends')}</IonCardTitle>
                    <IonCardSubtitle mode="md" className="ml-2">{api.tr('manage_friends')}</IonCardSubtitle>
                  </IonCol>
                  {/* {!isDisabled ? <IonReorder/> : null} */}
                </IonRow>
              </IonCardHeader>
              <IonCardContent>
                <IonItem onClick={(e)=> {
                  e.preventDefault()
                  e.stopPropagation()
                  goToPage('/walk/friends')
                }}>
                  <IonLabel>{api.tr('view_friends')}</IonLabel>
                  <IonButton slot="end" fill="clear">
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonItem>
                <IonItem onClick={(e)=> {
                  e.preventDefault()
                  e.stopPropagation()
                  goToPage('/walk/friends/search')
                }}>
                  <IonLabel>{api.tr('find_new_friends')}</IonLabel>
                  <IonButton slot="end" fill="clear">
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonItem>
              </IonCardContent>
            </IonCard>
            <IonCard 
              className="m-2" 
              routerLink="/walk/networks">
                <IonCardHeader color="light" className="p-2">
                <IonRow>
                  <IonCol size="1">
                    <IonIcon icon={people} size="large" color="teal"/>
                  </IonCol>
                  <IonCol>
                    <IonCardTitle mode="md" className="ml-2">{api.tr('find_page_network')}</IonCardTitle>
                    <IonCardSubtitle mode="md" className="ml-2">{api.tr('friends_info')}</IonCardSubtitle>
                  </IonCol>
                  {/* {!isDisabled ? <IonReorder/> : null} */}
                </IonRow>
              </IonCardHeader>
              <IonCardContent>
                <IonItem onClick={(e)=> {
                  e.preventDefault()
                  e.stopPropagation()
                  goToPage('/walk/networks')
                }}>
                  <IonLabel>{api.tr('view_network')}</IonLabel>
                  <IonButton slot="end" fill="clear">
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonItem>
                <IonItem onClick={(e)=> {
                  e.preventDefault()
                  e.stopPropagation()
                  goToPage('/walk/networks/explore')
                }}>
                  <IonLabel>{api.tr('find_network')}</IonLabel>
                  <IonButton slot="end" fill="clear">
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonItem>
              </IonCardContent>
            </IonCard>
          {/* </IonReorderGroup> */}
        </IonGrid>
      </section>
        <IonModal 
          isOpen={picture.open}
          onDidDismiss={() => setPicture({
            ...picture,
            open: false
            })}
          className="editprofileModal">
          <UploadPicture 
            closeModal={() => setPicture({
              ...picture,
              open: false
              })}
            setPicture={(pic: string) => uploadPicture(pic)}
            picture="assets/images/profile.png" />
        </IonModal>
        <SafetyPadding/>
      </IonContent>
    </IonPage>
  )
}

export default MyPage
